module.exports = __webpack_public_path__ + "img/printed_express.d30813c8.svg";